import request from '@/utils/request';

export function getGgoodsList(data) {
	return request({
		url: '/ggoods/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getGgoodsDetail(data) {
	return request({
		url: '/ggoods/detail',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getSameCategoryGgoods(data) {
	return request({
		url: '/ggoods/listTop4',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//장바구니 추가
export function addCart(data) {
	return request({
		url: '/ggoods/addCart',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

//견적담기
export function addEstimate(data) {
	return request({
		url: '/estimate/addEstimateCart',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 상품rm체크 호출
export function getPossible(data) {
	return request({
		url: '/v2/order/possible',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

// 신규 가격 API 추가
export function getGgoodsOptions(data) {
	return request({
		url: '/ggoods/price',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
